/* ══════════════════════════════════════════════════
   HV Partnership Program Pages — Shared JS
   FAQ accordion, form handler, scroll animations
   ══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Scroll fade observer ── */
  function initFade() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.hv-pp-fade').forEach(function (el) { el.classList.add('hv-vis'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hv-vis'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.hv-pp-fade').forEach(function (el) { obs.observe(el); });
  }

  /* ── FAQ Accordion ── */
  function initFAQ() {
    document.querySelectorAll('.hv-pp-faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.hv-pp-faq-item');
        var isOpen = item.classList.contains('hv-open');
        // Close all in same section
        var section = btn.closest('.hv-pp-faq__list');
        if (section) {
          section.querySelectorAll('.hv-pp-faq-item.hv-open').forEach(function (o) {
            o.classList.remove('hv-open');
            o.querySelector('.hv-pp-faq-item__q').setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          item.classList.add('hv-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Form Handler ── */
  function initForms() {
    document.querySelectorAll('.hv-pp-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.hv-pp-form__submit');
        var origText = btn.textContent;
        btn.textContent = 'SUBMITTING...';
        btn.disabled = true;

        var data = {};
        var inputs = form.querySelectorAll('input, select, textarea');
        inputs.forEach(function (inp) {
          if (inp.type === 'checkbox') {
            if (!data[inp.name]) data[inp.name] = [];
            if (inp.checked) data[inp.name].push(inp.value);
          } else if (inp.type === 'radio') {
            if (inp.checked) data[inp.name] = inp.value;
          } else {
            data[inp.name] = inp.value;
          }
        });
        data.source = 'partners-page';
        data.page = window.location.pathname;
        data.timestamp = new Date().toISOString();

        var webhook = form.getAttribute('data-webhook') || '';
        if (!webhook) webhook = 'https://services.leadconnectorhq.com/hooks/cuJ3zI8IC0m4JKc9x0SU/webhook-trigger/partnership-apply';

        fetch(webhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
          mode: 'no-cors'
        }).then(function () { showSuccess(form, data); })
          .catch(function () { showSuccess(form, data); });
      });
    });
  }

  function showSuccess(form, data) {
    var name = (data.full_name || data.fullName || data.contact_name || '').split(' ')[0] || 'Partner';
    form.innerHTML =
      '<div style="text-align:center;padding:48px 20px;">' +
        '<div style="width:60px;height:60px;background:rgba(201,169,78,0.15);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 24px;">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A94E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        '</div>' +
        '<h3 style="font-family:Pathway Gothic One,sans-serif;font-size:1.8rem;text-transform:uppercase;letter-spacing:3px;margin-bottom:12px;color:#ffffff;">APPLICATION RECEIVED</h3>' +
        '<p style="font-family:Montserrat,sans-serif;color:rgba(255,255,255,0.65);font-size:0.95rem;line-height:1.7;">Thank you, <strong style="color:#C9A94E;">' + name + '</strong>. Our partnerships team will review your application and reach out within 1-2 business days.</p>' +
      '</div>';
  }

  /* ── Init ── */
  function init() { initFade(); initFAQ(); initForms(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
